import { createSlice } from "@reduxjs/toolkit";
import {
  addProduct,
  deleteProduct,
  getProducts,
  updateProduct,
} from "../apiActions/productAction";
import handleApiMessage from "../../utils/handleApiError";

type Product = {
  id: string;
  name: string;
  created_at: string;
};

type ProductState = {
  products: Product[];
  error: null | string;
  loading: {
    getProduct: boolean;
    addProduct: boolean;
    deleteProduct: boolean;
    updateProduct: boolean;
  };
};

const initialState: ProductState = {
  products: [],
  error: null,
  loading: {
    getProduct: false,
    addProduct: false,
    deleteProduct: false,
    updateProduct: false,
  },
};

const productSlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state: ProductState) => {
        state.loading.getProduct = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state: ProductState, action) => {
        state.loading.getProduct = false;
        state.error = null;
        state.products = action.payload;
      })
      .addCase(getProducts.rejected, (state: ProductState, action: any) => {
        state.loading.getProduct = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(addProduct.pending, (state: ProductState) => {
        state.loading.addProduct = true;
        state.error = null;
      })
      .addCase(addProduct.fulfilled, (state: ProductState, action) => {
        state.loading.addProduct = false;
        state.error = null;
      })
      .addCase(addProduct.rejected, (state: ProductState, action: any) => {
        state.loading.addProduct = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(deleteProduct.pending, (state: ProductState) => {
        state.loading.deleteProduct = true;
        state.error = null;
      })
      .addCase(deleteProduct.fulfilled, (state: ProductState, action) => {
        state.loading.deleteProduct = false;
        state.error = null;
      })
      .addCase(deleteProduct.rejected, (state: ProductState, action: any) => {
        state.loading.deleteProduct = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(updateProduct.pending, (state: ProductState) => {
        state.loading.updateProduct = true;
        state.error = null;
      })
      .addCase(updateProduct.fulfilled, (state: ProductState, action) => {
        state.loading.updateProduct = false;
        state.error = null;
      })
      .addCase(updateProduct.rejected, (state: ProductState, action: any) => {
        state.loading.updateProduct = false;
        handleApiMessage(action.payload.description, "error");
      });
  },
});

export default productSlice.reducer;
